import React, { Component } from "react"
import ReactEcharts from "echarts-for-react"

class Candlestick extends Component {
  getOption = () => {
    return {
      tooltip: {
        trigger: "axis",
      },
      toolbox: {
        show: false,
        feature: {
          saveAsImage: {},
        },
      },
      grid: {
        zlevel: 0,
        x: 50,
        x2: 50,
        y: 30,
        y2: 30,
        borderWidth: 0,
        backgroundColor: "rgba(0,0,0,0)",
        borderColor: "rgba(0,0,0,0)",
      },
      xAxis: {
        data: ["9:00", "12:00", "15:00", "18:00"],
        axisLine: {
          lineStyle: {
            color: "#74788d",
          },
        },
      },
      yAxis: {
        axisLine: {
          lineStyle: {
            color: "#74788d",
          },
        },
      },
      series: [
        {
          type: "k",
          data: [
            [20, 30, 10, 35],
            [40, 35, 30, 55],
            [33, 38, 33, 40],
            [40, 40, 32, 42],
          ],
          itemStyle: {
            normal: {
              color: "#3c4ccf",
              color0: "#02a499",
              borderColor: "#3c4ccf",
              borderColor0: "#02a499",
            },
          },
        },
      ],
    }
  }
  render() {
    return (
      <React.Fragment>
        <ReactEcharts style={{ height: "300px" }} option={this.getOption()} />
      </React.Fragment>
    )
  }
}
export default Candlestick
